import { toast } from 'sonner';
import { adminApi } from '../../../lib/adminAuth';

export const inr = (n) => `₹${Number(n || 0).toLocaleString('en-IN', { maximumFractionDigits: 0 })}`;
export const publicBase = () => window.location.origin;
export const errMsg = (e, fallback) => e?.response?.data?.detail || fallback;
export const fmtDate = (v) => (v ? new Date(v).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' }) : '—');

export const STATUS = {
  draft: { label: 'Draft', cls: 'bg-slate-100 text-slate-700' },
  sent: { label: 'Sent', cls: 'bg-sky-100 text-sky-700' },
  viewed: { label: 'Viewed', cls: 'bg-indigo-100 text-indigo-700' },
  signed: { label: 'Signed', cls: 'bg-emerald-100 text-emerald-700' },
  accepted: { label: 'Accepted', cls: 'bg-emerald-100 text-emerald-700' },
  converted: { label: 'Converted', cls: 'bg-fuchsia-100 text-fuchsia-700' },
  declined: { label: 'Declined', cls: 'bg-rose-100 text-rose-700' },
  expired: { label: 'Expired', cls: 'bg-amber-100 text-amber-800' },
  void: { label: 'Void', cls: 'bg-neutral-200 text-neutral-600 line-through' },
};

export const PLACEHOLDERS = [
  ['{{brand}}', 'Brand name'], ['{{client_legal_name}}', 'Client legal name'], ['{{fee}}', 'Monthly fee, e.g. Rs. 1,75,000'],
  ['{{fee_words}}', 'Fee in words'], ['{{invoice_day}}', 'Invoice day, e.g. 1st'], ['{{payment_due_day}}', 'Payment due day, e.g. 5th'],
  ['{{notice_period}}', "e.g. thirty (30) days'"], ['{{credit_months}}', 'e.g. two (2)'], ['{{start_date}}', 'Start date'],
  ['{{jurisdiction_city}}', 'Courts city'], ['{{ref:clause_key}}', 'Number of another clause, e.g. 3.3'], ['{{sec:section_key}}', 'Number of a section, e.g. 6'],
];

export async function downloadPdf(url, filename) {
  try {
    const r = await adminApi.get(url, { responseType: 'blob', timeout: 60000 });
    const href = URL.createObjectURL(new Blob([r.data], { type: 'application/pdf' }));
    const a = document.createElement('a');
    a.href = href; a.download = filename; document.body.appendChild(a); a.click(); a.remove();
    setTimeout(() => URL.revokeObjectURL(href), 2000);
  } catch (e) { toast.error('Could not download the PDF'); }
}

export async function copyShareLink(url) {
  try {
    const r = await adminApi.post(url, { public_base_url: publicBase() });
    await navigator.clipboard?.writeText(r.data.link).catch(() => {});
    toast.success('Sign link copied', { description: r.data.link });
    return r.data.link;
  } catch (e) { toast.error(errMsg(e, 'Could not create the link')); return null; }
}

export const fileName = (num) => `${(num || 'document').replace(/\//g, '-')}.pdf`;

export function addMonthsEnd(start, months) {
  const m = Number(months);
  if (!start || !m) return '';
  const d = new Date(`${start}T00:00:00`);
  const day = d.getDate();
  d.setDate(1); d.setMonth(d.getMonth() + m);
  const last = new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate();
  d.setDate(Math.min(day, last)); d.setDate(d.getDate() - 1);
  return d.toLocaleDateString('en-CA');
}
